var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNiveauBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: #1c428c;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16,
    y: 0,
    width: 79,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 11,
    width: 23,
    height: 2,
    transform: "translate(4 27) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84,
    y: 11,
    width: 23,
    height: 2,
    transform: "translate(84 107) rotate(-90)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 23,
    width: 111,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37,25h-6c-2,0-4-2-4-4V9c0-2,2-4,4-4h6c2,0,4,2,4,4v12c0,2-2,4-4,4ZM31,7c-1,0-2,1-2,2v12c0,1,1,2,2,2h6c1,0,2-1,2-2V9c0-1-1-2-2-2h-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,15c-1,0-1,0-1-1s0-1,1-1,1,0,1,1,0,1-1,1ZM32,14c0,0,0,0,0,0s0,0,0,0,0,0,0,0,0,0,0,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiveauBase);
export default __webpack_public_path__ + "static/media/niveau-base.8ac63a23e886599c88a163d7fd814c1c.svg";
export { ForwardRef as ReactComponent };